import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { MunicipalityManagementConfigurationStore } from '@app/municipality-management/services/municipality-management-configuration.store';
import { RegionManagementComponent } from '@app/region-management/region-management.component';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { isNil } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class RegionManagementDeactivateGuard implements CanDeactivate<RegionManagementComponent> {
  constructor(private _configStore: MunicipalityManagementConfigurationStore, private matDialog: MatDialog) {}

  canDeactivate(): boolean {
    if (!isNil(this._configStore.hasNoOrphanedMunicipality) && this._configStore.hasNoOrphanedMunicipality) {
      return true;
    } else {
      this.matDialog.open(NotificationDialogComponent, {
        data: {
          descriptionText: `Es sind noch Kommunen ohne Zuordnung vorhanden. Bitte ordnen Sie die Kommunen den Regionen zu, bevor Sie die Seite verlassen.`,
          confirmText: 'Ok',
        },
        panelClass: ['-md'],
      });
      return false;
    }
  }
}
